import { useState, useCallback } from "react";
import { authActions, selectedAuthAccessToken } from "@src/ducks/slices/auth.slice";
import { useAppDispatch, useAppSelector } from "@src/ducks/ducksHook";
import { ErrorValue, FetchPostProps } from "./useFetchPost";
import { CurrentApi } from "../request";

export const useFetchPut = (initialData = {}) => {
  const dispatch = useAppDispatch();
  const [error, setError] = useState<ErrorValue>({} as ErrorValue);
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState<boolean>(false);
  const accessToken = useAppSelector(selectedAuthAccessToken);

  const runRequest = useCallback(
    async (routes: string, params: any) => {
      try {
        setLoading(true);
        CurrentApi.setToken(accessToken);
        const result = await CurrentApi.put(`${routes}`, params);

        setData({status: result.status, ...result.data});
      } catch (err: any) {
        let message = err.message || err.error || "Something went wrong";
        message = message.replace(/^HttpException:\s*/, "");
        setError({ message });
        if ((message.includes("Unauthorized") || message.includes("Failed to fetch"))) {
          dispatch(authActions.logout());
        }
      } finally {
        setLoading(false);
      }
    },
    [accessToken, dispatch]
  );

  return {
    loading,
    data,
    error,
    runRequest,
  } as FetchPostProps;
};
